import ReactionItemTemplate from '../templates/ReactionItemTemplate'
import {reactionsData} from '../../helpers/data/reactions-data'
import {ReactionContext} from '../../helpers/context'
import {useContext} from 'react'

const ReactionItem = ({type, isProud, size}) => {
  const {setReaction} = useContext(ReactionContext)
  const reaction = reactionsData[type]

  return (
    <ReactionItemTemplate
      type={type}
      isProud={isProud}
      size={size}
      onClick={() => setReaction(reaction)}
    />
  )
}

export default ReactionItem
